import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	container: {
		border: `1px solid ${colors.beige[100]}`,
		borderRadius: theme.spacing(0.5),
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[0]),
		padding: theme.spacing(1, 1.5)
	},
	text: {
		flex: 1,
		fontWeight: 500
	}
}))

export default useStyles
